import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaginateData } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ExentosService {

  private ENDPOINTPERSONA = environment.ENDPOINTS.EXE_PERSONA;
  private ENDPOINTVEHICULO = environment.ENDPOINTS.EXE_VEHICULO;
  private ENDPOINTBUSQUEDA = environment.ENDPOINTS.EXE_BUSQUEDA;
  private ENPOINTHISTORIAL = environment.ENDPOINTS.EXE_HISTORIAL;
  private ENDPOINT = environment.ENDPOINTS.API;
  constructor(
    private http:HttpClient,
  ) { }

  getDataExentos(formData){
    return this.http.post<any>(this.ENDPOINTBUSQUEDA, formData);
  }
  getExentos(){
    return this.http.get<any[]>(this.ENDPOINTVEHICULO);

  }

  busquedaPersonalizada(Data) {
    return this.http.post<any>(`${this.ENDPOINTBUSQUEDA}`, Data).toPromise();
  }

  savePersonaExento(formData) {
    return this.http.post<any>(this.ENDPOINTPERSONA, formData).toPromise();
  }

  updatePersonaExento(formData) {
    return this.http.put<any>(`${this.ENDPOINTPERSONA}/1`, formData).toPromise();
  }

  saveVehiculoPersona(formData) {
    return this.http.post<any>(`${this.ENDPOINTPERSONA}/saveVehiculos`, formData).toPromise();
  }

  getFolioTarjeton(tipoPase:number) {
    return this.http.get<string>(`${this.ENDPOINTVEHICULO}/tarjeton/consecutivo/${tipoPase}`).toPromise();
  }

  getTiposPase() {
    return this.http.get<any>(`${this.ENDPOINT}/subcruceExentos`).toPromise();
    // return this.http.get<any>(`${this.ENDPOINT}/subcruceExentos`);

  }

  getDescuentos() {
    return this.http.get<any>(`${this.ENDPOINT}/descuentos`).toPromise();
  }

  getTarjetonActivos(no_tarjeton:number, tipo_pase) {
    return this.http.get<any>(`${this.ENDPOINTVEHICULO}/${no_tarjeton}/${tipo_pase}`).toPromise();
  }

  showVehiculo(id_vehiculo:number){
    return this.http.get<any>(`${this.ENDPOINTVEHICULO}/${id_vehiculo}`).toPromise();
  }

  getDocumentosExentos(id,form){
    return this.http.post<any>(`${this.ENDPOINT}/documentos_exe/${id}`,form).toPromise();
  }

  downloadTarjetones(vehiculos) {
    const httpOptions = {responseType: 'blob' as 'json'};
    return this.http.post<any>(`${this.ENDPOINTVEHICULO}/download/file/tarjetones`,vehiculos,httpOptions).toPromise();
  }

  downloadFileTarjetones(file:Blob, nameFile) {
      const url = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = url;
      link.download = nameFile;
      link.click();
      return url;
  }

  previewFileTarjetones(file:Blob){
  const reader = new FileReader();
  return reader.readAsDataURL(file);
  }

  modificarVehiculo(id, formData) {
    return this.http.put<any>(`${this.ENDPOINTVEHICULO}/${id}`,formData).toPromise();
  }

  modificarPropietario(data){
    return this.http.post<any>(`${this.ENDPOINTVEHICULO}/modificarPropietario`,data).toPromise();
  }

  getHistorialById(id_vehiculo){
    return this.http.get<any>(`${this.ENPOINTHISTORIAL}/${id_vehiculo}`).toPromise();
  }

  getPersonaAll(){
    return this.http.get<any>(`${this.ENDPOINTPERSONA}/0`).toPromise();
  }
}
